import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);   // null=loading, false=guest, obj=user
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    const token = localStorage.getItem("ait_token");
    if (!token) { setUser(false); setLoading(false); return; }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      localStorage.removeItem("ait_token");
      setUser(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.requires_2fa) return data;
    localStorage.setItem("ait_token", data.token);
    localStorage.removeItem("ait_support_session");
    setUser(data.user);
    return data.user;
  };

  const verifyTwoFactor = async (challenge_token, code) => {
    const { data } = await api.post("/auth/2fa/verify", { challenge_token, code });
    localStorage.setItem("ait_token", data.token);
    localStorage.removeItem("ait_support_session");
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("ait_token");
    localStorage.removeItem("ait_support_session");
    setUser(false);
  };

  const isAdmin = user && (user.role === "admin" || user.role === "super_admin");

  return (
    <AuthContext.Provider value={{ user, loading, login, verifyTwoFactor, logout, refresh, setUser, isAdmin }}>
      {children}
    </AuthContext.Provider>
  );
}
